import {
	alpha,
	darken,
	getOverlayAlpha,
	lighten,
	useTheme,
} from "@mui/material/styles";
import { useMemo } from "react";
import { getModeBasedBackgroundElevation } from "../themes";

export const useThemedColors = () => {
	const theme = useTheme();

	const { BACKGROUND_DEFAULT_ELEVATION, BACKGROUND_PAPER_ELEVATION } =
		getModeBasedBackgroundElevation(theme.palette.mode);

	return useMemo(
		() => ({
			overlay: alpha(theme.palette.common.black, 0.5),
			overlayAlpha: 0.5,
			neutralGreyDark: lighten(theme.palette.common.black, 0.2),
			neutralGrey: lighten(theme.palette.common.black, 0.5),
			neutralGreyLight: lighten(theme.palette.common.black, 0.9),
			action: {
				hover: {
					primary: alpha(
						theme.palette.primary.main,
						theme.palette.action.hoverOpacity,
					),
					secondary: alpha(
						theme.palette.secondary.main,
						theme.palette.action.hoverOpacity,
					),
					info: alpha(
						theme.palette.info.main,
						theme.palette.action.hoverOpacity,
					),
					warning: alpha(
						theme.palette.warning.main,
						theme.palette.action.hoverOpacity,
					),
					error: alpha(
						theme.palette.error.main,
						theme.palette.action.hoverOpacity,
					),
					success: alpha(
						theme.palette.success.main,
						theme.palette.action.hoverOpacity,
					),
				},
				selected: {
					primary: alpha(
						theme.palette.primary.main,
						theme.palette.action.selectedOpacity,
					),
					secondary: alpha(
						theme.palette.secondary.main,
						theme.palette.action.selectedOpacity,
					),
					info: alpha(
						theme.palette.info.main,
						theme.palette.action.selectedOpacity,
					),
					warning: alpha(
						theme.palette.warning.main,
						theme.palette.action.selectedOpacity,
					),
					error: alpha(
						theme.palette.error.main,
						theme.palette.action.selectedOpacity,
					),
					success: alpha(
						theme.palette.success.main,
						theme.palette.action.selectedOpacity,
					),
				},
				disabled: {
					primary: alpha(
						theme.palette.primary.main,
						theme.palette.action.disabledOpacity,
					),
					secondary: alpha(
						theme.palette.secondary.main,
						theme.palette.action.disabledOpacity,
					),
					info: alpha(
						theme.palette.info.main,
						theme.palette.action.disabledOpacity,
					),
					warning: alpha(
						theme.palette.warning.main,
						theme.palette.action.disabledOpacity,
					),
					error: alpha(
						theme.palette.error.main,
						theme.palette.action.disabledOpacity,
					),
					success: alpha(
						theme.palette.success.main,
						theme.palette.action.disabledOpacity,
					),
				},
				focus: {
					primary: alpha(
						theme.palette.primary.main,
						theme.palette.action.focusOpacity,
					),
					secondary: alpha(
						theme.palette.secondary.main,
						theme.palette.action.focusOpacity,
					),
					info: alpha(
						theme.palette.info.main,
						theme.palette.action.focusOpacity,
					),
					warning: alpha(
						theme.palette.warning.main,
						theme.palette.action.focusOpacity,
					),
					error: alpha(
						theme.palette.error.main,
						theme.palette.action.focusOpacity,
					),
					success: alpha(
						theme.palette.success.main,
						theme.palette.action.focusOpacity,
					),
				},
			},
			backgroundDefaultElevation: BACKGROUND_DEFAULT_ELEVATION,
			backgroundPaperElevation: BACKGROUND_PAPER_ELEVATION,
			elevatePaperBackground: (elevation: number) =>
				theme.palette.mode === "light"
					? darken("#ffffff", +getOverlayAlpha(elevation))
					: lighten("#121212", +getOverlayAlpha(elevation)),
		}),
		[theme, BACKGROUND_DEFAULT_ELEVATION, BACKGROUND_PAPER_ELEVATION],
	);
};
